//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"Mw5axisReversed",1,0]],[[["count","items"],"GetMw5axisGeometries",{},0,0],[["items"],"SetMw5axisGeometries",{},1,0],[["count"],"GetMw5axisGenericValues",{R_:{values:""}},0,0],[["values"],"SetMw5axisGenericValues",{},1,0],[[],"GetMw5axisGeometry",{R_:{item:"TaggedObject"}},0,0],[["item"],"SetMw5axisGeometry",{},1,0]],[]];
SPLM.CAM.ToolPathMW5Axis = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ToolPathMW5Axis";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;